import '@ali/aps-dev/dist/css/aps.css';
import React, { Component } from 'react';
import { Grid, Icon } from '@ali/aps-dev';
import './screen.scss';

const Row = Grid.Row;
const Col = Grid.Col;

class ScreenBar extends Component {
  constructor(props) {
    super(props);
    this.barInfo = this.props.barInfo;
  }
  render() {
    let up = <span><span>收起</span><Icon type="arrow-up" className="arrow" /></span>;
    let down = <span><span>筛选</span><Icon type="arrow-down" className="arrow" /></span>;
    return (
      <Row>
        <Col lg={21} md={21} sm={21} xs={18}>
          <p className="result-count-p">
            共有<span className="result-count">{this.props.totalNum}</span>个搜索结果
          </p>
        </Col>
        <Col
          lg={3} md={3} sm={3} xs={6}
          className={this.barInfo.isShowCheckList ? 'checked' : 'check'}
          onClick={this.barInfo.handlerShowCheckList}>
          <p>{this.barInfo.isShowCheckList ? up : down}</p>
        </Col>
      </Row>
    );
  }
}
export default ScreenBar;


// WEBPACK FOOTER //
// ./src/components/Screen/ScreenBar.js